export interface SearchUsersRequest {
  name: string
  id: string
  birthday: string
  phoneNumber: string
  address: string
  mailAddress: string
  gender: string
  userType: string
  status: string
  areaCode: string
  workType: string
  studentGrade: string
  studentClass: string
  studentNumber: string
}

export function SearchUsersRequestToJSON(value: SearchUsersRequest): any {
  return {
    name: value.name !== '' ? value.name : undefined,
    id: value.id !== '' ? value.id : undefined,
    birthday: value.birthday !== '' ? value.birthday : undefined,
    phone_number: value.phoneNumber !== '' ? value.phoneNumber : undefined,
    address: value.address !== '' ? value.address : undefined,
    mail_address: value.mailAddress !== '' ? value.mailAddress : undefined,
    gender: value.gender !== '' ? value.gender : undefined,
    user_type: value.userType !== '' ? value.userType : undefined,
    status: value.status !== '' ? value.status : undefined,
    area_code: value.areaCode !== '' ? value.areaCode : undefined,
    work_type: value.workType !== '' ? value.workType : undefined,
    student_grade: value.studentGrade !== '' ? value.studentGrade : undefined,
    student_class: value.studentClass !== '' ? value.studentClass : undefined,
    student_number: value.studentNumber !== '' ? value.studentNumber : undefined
  }
}
